import React, { useState } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth, database, storage } from './firebaseConfig';
import { doc, setDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import './signup.css';
import './Login.css';
import './Modal.css';
import './ContactModal.css';
import { useNavigate } from 'react-router-dom';

const Signup = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [address, setAddress] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [companyTitle, setCompanyTitle] = useState('');
  const [logo, setLogo] = useState(null);
  const [message, setMessage] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const navigate = useNavigate();


  const handleLogoChange = (e) => {
    if (e.target.files[0]) {
      setLogo(e.target.files[0]);
    }
  };

  const handleSignup = async (e) => {
    e.preventDefault();

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      let logoUrl = '';
      if (logo) {
        const logoRef = ref(storage, `logos/${email}`);
        await uploadBytes(logoRef, logo);
        logoUrl = await getDownloadURL(logoRef);
      }

      await setDoc(doc(database, 'users', email), {
        email: email,
        uid: user.uid,
        address: address,
        phoneNumber: phoneNumber,
        companyName: companyName,
        companyTitle: companyTitle,
        logoUrl: logoUrl,
        createdAt: new Date().toISOString()
      });

      await setDoc(
        doc(database, 'users', email, 'kontor', 'current'),
        {
          amount: 100,
          lastUpdated: new Date().toISOString(),
          createdAt: new Date().toISOString(),
          history: [
            {
              date: new Date().toISOString(),
              amount: 100,
              type: 'initial',
              description: 'Yeni kullanıcı başlangıç kontörü'
            }
          ]
        }
      );

      setMessage('Kayıt başarılı!');
      setShowPopup(true);

      setTimeout(() => {
        setShowPopup(false);
        navigate('/');
      }, 2000);
    } catch (error) {
      console.error('Kayıt hatası:', error);
      setMessage('Kayıt başarısız: ' + error.message);
    }
  };

  return (
    <section className="login-section">
      <div className="wave">
        <span></span>
        <span></span>
        <span></span>
      </div>
      
      {/* Logo */}
      <div className="logo-container">
        <h1 className="logo-text" onClick={() => window.location.href = 'https://www.hopssoftware.com'}>Hops Software</h1>
      </div>
      
      <div className="signup-container">
        <h2>Kayıt Ol</h2>
        <form onSubmit={handleSignup} className="signup-form">
          <div className="form-section account-section">
            <h3>Hesap Bilgileri</h3>
            <p className="section-description">
              Sisteme giriş yapmak için kullanacağınız hesap bilgileriniz.
            </p>
            <div className="input-group">
              <input
                type="email"
                placeholder="E-posta"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="signup-input"
              />
              <small className="input-description">
                Bu e-posta adresi ile sisteme giriş yapacaksınız.
              </small>
            </div>
            <div className="input-group">
              <input
                type="password"
                placeholder="Şifre"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="new-password"
                className="signup-input"
              />
              <small className="input-description">
                Güvenli bir şifre seçin. En az 6 karakter kullanın.
              </small>
            </div>
          </div>

          <div className="form-section company-section">
            <h3>Puantaj Bilgileri</h3>
            <p className="section-description">
              Puantaj formlarında ve sistemde görüntülenecek firma bilgileriniz.
            </p>
            <div className="input-group">
              <input
                type="text"
                placeholder="Firma Adı"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                required
                className="signup-input"
              />
              <small className="input-description">
                Puantaj formlarında görünecek firma adınız.
              </small>
            </div>
            <div className="input-group">
              <input
                type="text"
                placeholder="Firma Unvanı"
                value={companyTitle}
                onChange={(e) => setCompanyTitle(e.target.value)}
                required
                className="signup-input"
              />
              <small className="input-description">
                Resmi işlemlerde kullanılacak firma unvanınız.
              </small>
            </div>
            <div className="input-group">
              <input
                type="text"
                placeholder="Adres"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                required
                className="signup-input"
              />
              <small className="input-description">
                Puantaj formlarında görünecek firma adresiniz.
              </small>
            </div>
            <div className="input-group">
              <input
                type="text"
                placeholder="Telefon Numarası"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                required
                className="signup-input"
              />
              <small className="input-description">
                İletişim için kullanılacak telefon numaranız.
              </small>
            </div>
            <div className="input-group">
              <div className="file-input-container">
                <label htmlFor="logo-upload" className="file-input-label">
                  Logo Seç
                </label>
                <input
                  id="logo-upload"
                  type="file"
                  accept="image/*"
                  onChange={handleLogoChange}
                  className="file-input"
                />
                {logo && <span className="file-name">{logo.name}</span>}
              </div>
              <small className="input-description">
                Puantaj formlarında ve sistemde görüntülenecek firma logonuz.
              </small>
            </div>
          </div>

          <button type="submit" className="signup-button">Kayıt Ol</button>
          {message && <p className="signup-message">{message}</p>}
        </form>
    
        {showPopup && (
          <div className="popup-message">
            Kullanıcı başarıyla oluşturuldu!
          </div>
        )}
      </div>
      
      {/* Footer */}
      <footer className="login-footer">
        <div className="footer-content">
          <p>&copy; 2024 Hops Software. Tüm hakları saklıdır.</p>
            <div className="footer-links">
              <a href="#privacy" onClick={(e) => { e.preventDefault(); setShowPrivacyModal(true); }} className="footer-link">Gizlilik Politikası</a>
              <span className="footer-separator">•</span>
              <a href="#terms" onClick={(e) => { e.preventDefault(); setShowTermsModal(true); }} className="footer-link">Kullanım Şartları</a>
              <span className="footer-separator">•</span>
              <a href="#support" onClick={(e) => { e.preventDefault(); setShowContactModal(true); }} className="footer-link">Destek</a>
            </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      {showPrivacyModal && (
        <div className="legal-modal-overlay" onClick={() => setShowPrivacyModal(false)}>
          <div className="legal-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="legal-modal-close" onClick={() => setShowPrivacyModal(false)}>×</button>
            <div className="legal-modal-body">
              <h2 className="legal-modal-title">Gizlilik Sözleşmesi</h2>
              
              <h3>1. Veri Toplama ve Kullanım</h3>
              <p>HOPS olarak, hizmetlerimizi kullanırken sizden toplanan kişisel verilerin gizliliğini korumayı taahhüt ediyoruz. Bu veriler arasında isim, e-posta adresi, telefon numarası ve şirket bilgileri bulunmaktadır.</p>
              
              <h3>2. Veri Güvenliği</h3>
              <p>Verileriniz, endüstri standardı güvenlik protokolleri ve şifreleme teknolojileri kullanılarak korunmaktadır. Yetkisiz erişim, değiştirme veya ifşaya karşı uygun güvenlik önlemleri alınmaktadır.</p>
              
              <h3>3. Veri Paylaşımı</h3>
              <p>Kişisel verileriniz, yasal zorunluluklar dışında üçüncü taraflarla paylaşılmamaktadır. Hizmet sağlayıcılarımızla yapılan veri paylaşımları, gizlilik sözleşmeleri kapsamında gerçekleştirilmektedir.</p>
              
              <h3>4. Çerezler ve İzleme</h3>
              <p>Platformumuzda, kullanıcı deneyimini iyileştirmek için çerezler kullanılmaktadır. Bu çerezler, oturum bilgilerini ve kullanıcı tercihlerini saklamak için kullanılır.</p>
              
              <h3>5. Kullanıcı Hakları</h3>
              <p>KVKK kapsamında, kişisel verilerinize erişim, düzeltme, silme ve işleme itiraz etme haklarına sahipsiniz. Bu haklarınızı kullanmak için bizimle iletişime geçebilirsiniz.</p>
              
              <div className="legal-modal-contact">
                <h3>İletişim Bilgileri</h3>
                <p>Gizlilik politikamız hakkında sorularınız için:</p>
                <p>E-posta: info@hopssoftware.com</p>
                <p>Telefon: +90 552 464 11 16</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Terms Modal */}
      {showTermsModal && (
        <div className="legal-modal-overlay" onClick={() => setShowTermsModal(false)}>
          <div className="legal-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="legal-modal-close" onClick={() => setShowTermsModal(false)}>×</button>
            <div className="legal-modal-body">
              <h2 className="legal-modal-title">Mesafeli Satış Sözleşmesi</h2>
              
              <div className="legal-modal-section">
                <h3>1. Taraflar</h3>
                <p>İşbu sözleşme, HOPS (bundan sonra SATICI olarak anılacaktır) ile alıcı (bundan sonra ALICI olarak anılacaktır) arasında aşağıdaki şartlar çerçevesinde düzenlenmiştir.</p>
              </div>
              <div className="legal-modal-section">
                <h3>2. Sözleşmenin Konusu</h3>
                <p>İşbu sözleşmenin konusu, ALICI'nın SATICI'ya ait platform üzerinden satın aldığı kontör hizmetinin satışı ve teslimi ile ilgili olarak 6502 Sayılı Tüketicinin Korunması Hakkında Kanun hükümleri gereğince tarafların hak ve yükümlülüklerinin belirlenmesidir.</p>
              </div>
              <div className="legal-modal-section">
                <h3>3. Hizmet Bilgileri</h3>
                <p>Satın alınan kontör paketi, dijital bir hizmet olup, ödemenin tamamlanmasını takiben ALICI'nın hesabına otomatik olarak tanımlanacaktır. Kontörler, aktivasyon tarihinden itibaren süresiz olarak geçerlidir.</p>
              </div>
              <div className="legal-modal-section">
                <h3>4. Ödeme ve Teslimat</h3>
                <p>Ödeme, platform üzerinden kredi kartı veya banka kartı ile gerçekleştirilir. Kontörler, ödemenin başarıyla tamamlanmasının ardından anında hesaba tanımlanır. Dijital hizmet olması sebebiyle fiziksel teslimat söz konusu değildir.</p>
              </div>
              <div className="legal-modal-section">
                <h3>5. Cayma Hakkı</h3>
                <p>Dijital içerik/hizmet sunumu niteliğinde olan kontör satışlarında, hizmetin tesliminin/ifasının başladığı an itibarıyla cayma hakkı kullanılamaz. Bu husus 6502 Sayılı Kanun'un 15/1-ğ maddesi uyarınca cayma hakkı istisnası kapsamındadır.</p>
              </div>
              <div className="legal-modal-contact">
                <h3>Satıcı Bilgileri</h3>
                <p>Unvan: TUĞBA HAZAL ÖZKARAASLAN HOPS YAZILIM SİSTEMLERİ TEKNOPARK ŞUBESİ</p>
                <p>Adres: Yeniköy Merkez Mah. Vatan Cad. Teknopark Sitesi Başiskele / Kocaeli</p>
                <p>E-posta: info@hopssoftware.com</p>
                <p>Telefon: +90 552 464 11 16</p>
                <p>MERSİS No: 3888146357 / 154133525540002</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Contact/Support Modal */}
      {showContactModal && (
        <div className="contact-modal-overlay" onClick={() => setShowContactModal(false)}>
          <div className="contact-modal-container" onClick={(e) => e.stopPropagation()}>
            <div className="contact-modal-header">
              <div className="contact-modal-header-content">
                <h2 className="contact-modal-title">BİZİ ARAYIN</h2>
                <p className="contact-modal-subtitle">Sizi arayalım ve ihtiyacınız olan çözümü sunalım</p>
              </div>
              <div className="contact-modal-header-right">
                <span className="contact-modal-phone">+90 552 464 11 16</span>
                <button className="contact-modal-close" onClick={() => setShowContactModal(false)}>×</button>
              </div>
            </div>
            <div className="contact-modal-body">
              <form className="contact-modal-form">
                <div className="contact-form-group">
                  <input type="text" placeholder="Adınız Soyadınız" className="contact-form-input" required />
                </div>
                <div className="contact-form-group">
                  <input type="text" placeholder="Firma Adınız" className="contact-form-input" required />
                </div>
                <div className="contact-form-group">
                  <div className="contact-phone-group">
                    <select className="contact-country-code">
                      <option value="+90">+90</option>
                    </select>
                    <input type="tel" placeholder="Telefon Numaranız" className="contact-form-input contact-phone-input" required />
                  </div>
                </div>
                <div className="contact-form-group">
                  <input type="email" placeholder="E-posta Adresiniz" className="contact-form-input" required />
                </div>
                <div className="contact-agreements">
                  <div className="contact-agreement-item">
                    <div className="contact-checkbox-container">
                      <input type="checkbox" className="contact-checkbox" id="signup-contact-privacy" required />
                      <svg className="contact-checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                    </div>
                    <label htmlFor="signup-contact-privacy" className="contact-agreement-text">
                      Gizlilik sözleşmesini okudum ve kabul ediyorum
                    </label>
                  </div>
                  <div className="contact-agreement-item">
                    <div className="contact-checkbox-container">
                      <input type="checkbox" className="contact-checkbox" id="signup-contact-commercial" />
                      <svg className="contact-checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                    </div>
                    <label htmlFor="signup-contact-commercial" className="contact-agreement-text">
                      Ticari elektronik ileti almayı kabul ediyorum
                    </label>
                  </div>
                </div>
                <button type="submit" className="contact-submit-button">Gönder</button>
              </form>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Signup;